import type { StructuredContentDocument } from '@ria-client/supergraph/structuredContent/types';
import { Details, NerdWalletBadge } from '@ria-client/tw-shared-ui';
import { ChevronDown } from 'lucide-react';
import { StructuredContentRenderer } from '../../renderer';
import { ReadReviewLink } from './read-review-link';

export interface NerdwalletTakeProps {
  content?: StructuredContentDocument;
  reviewLink?: string;
  offerId: string;
  isDefaultExpanded?: boolean;
}

export function NerdwalletTake({
  content,
  reviewLink,
  offerId,
  isDefaultExpanded = false,
}: NerdwalletTakeProps) {
  const detailsId = `nerdwallet-take-details-${offerId}`;

  return (
    <Details
      SummaryComponent={
        <>
          <span className="flex items-center gap-3">
            <NerdWalletBadge />
            <span className="font-sans font-medium">NerdWallet&apos;s take</span>
          </span>
          <ChevronDown aria-hidden className="size-6" />
        </>
      }
      detailsProps={{ open: isDefaultExpanded }}
      summaryComponentProps={{
        'aria-controls': detailsId,
        className:
          'justify-between px-3.5 py-3 hover:outline-2 hover:outline-[var(--content-blue-focus-outline)]',
        id: `nerdwallet-take-header-${offerId}`,
      }}
      variant="simple"
    >
      <div className="p-0 md:px-3.5 md:pb-3.5 md:pt-2" id={detailsId}>
        <div className="flex flex-col gap-2 rounded-[4px] rounded-b-[8px] bg-[var(--content-green-extra-light)] p-3.5 break-words md:rounded-[4px]">
          <StructuredContentRenderer doc={content} />
          {reviewLink && <ReadReviewLink reviewLink={reviewLink} />}
        </div>
      </div>
    </Details>
  );
}
